export default __webpack_public_path__ + "static/media/ira1.77da5d75.jpg";